const FUNC_TYPES = {
  // 编辑
  EDIT: 'EDIT',
  // 删除
  DEL: 'DEL',
  // 提交
  SUBMIT: 'SUBMIT',
  // 查看
  DETAIL: 'DETAIL',
  // 审批
  APPROVAL: 'APPROVAL',
  // 撤销
  CANCEL: 'CANCEL',
  // 作废
  NULLIFY: 'NULLIFY',
  // 发货
  DELIVER_GOODS: 'DELIVER_GOODS',
  // 下载调拨单
  DOWNLOAD: 'DOWNLOAD',
  // 服务收货
  SERVICE_RECEIVING: 'SERVICE_RECEIVING',
  // 修改项目负责人
  MODIFY_PROJECT_LEADER: 'MODIFY_PROJECT_LEADER'
};

export default {
  data() {
    return {
      // 功能类别
      FUNC_TYPES: FUNC_TYPES,
      // 状态与对应的功能点关系
      funcRelation: [
        // 草稿
        {
          statusVal: 1,
          func: [FUNC_TYPES.EDIT, FUNC_TYPES.DEL, FUNC_TYPES.SUBMIT, FUNC_TYPES.DOWNLOAD, FUNC_TYPES.MODIFY_PROJECT_LEADER, FUNC_TYPES.DETAIL]
        },
        // 审批中
        {
          statusVal: 6,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.DETAIL, FUNC_TYPES.APPROVAL, FUNC_TYPES.MODIFY_PROJECT_LEADER, FUNC_TYPES.CANCEL]
        },
        // 审批通过
        {
          statusVal: 10,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.DETAIL, FUNC_TYPES.MODIFY_PROJECT_LEADER, FUNC_TYPES.NULLIFY, FUNC_TYPES.DELIVER_GOODS]
        },
        // 待发货
        {
          statusVal: 20,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.DETAIL, FUNC_TYPES.MODIFY_PROJECT_LEADER, FUNC_TYPES.DELIVER_GOODS]
        },
        // 审批拒绝
        {
          statusVal: 90,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.DETAIL]
        },
        // 已发货
        {
          statusVal: 21,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.MODIFY_PROJECT_LEADER, FUNC_TYPES.DETAIL, FUNC_TYPES.SERVICE_RECEIVING, FUNC_TYPES.DELIVER_GOODS]
        },
        // 已收货
        {
          statusVal: 22,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.MODIFY_PROJECT_LEADER, FUNC_TYPES.DETAIL, FUNC_TYPES.SERVICE_RECEIVING, FUNC_TYPES.DELIVER_GOODS]
        },
        // 已完成
        {
          statusVal: 80,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.MODIFY_PROJECT_LEADER, FUNC_TYPES.DETAIL]
        },
        // 已作废
        {
          statusVal: 100,
          func: [FUNC_TYPES.DOWNLOAD, FUNC_TYPES.DETAIL]
        }
      ]
    };
  },
  methods: {
    /**
     * @description 判断是否有相应权限
     * @param {number} status 状态 orderStatus
     * @param {string} funcType 功能类型
     * @return {boolean} 是否有权限
     */
    checkRole(status, funcType) {
      const retItem = this.funcRelation.find(item => item.statusVal === status);
      if (!retItem) {
        return false;
      }
      return retItem.func.includes(funcType);
    }
  }
};
